import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import removerFiltroTomador from '../../actions/cteos/tomador/removerFiltroTomador'

export class FiltrosAdicionadosTomador extends Component {
  exibirFiltro (filtro) {
    if (filtro.isData) {
      if (filtro.valor.inicio && filtro.valor.fim) {
        return (
          <div className="col-xl-auto justify-content-md-center"
               key={`${filtro.chave}${filtro.valor.inicio}${filtro.valor.fim}`}>
            <span className="badge badge-secondary badge-filtro">
              {filtro.label} = {`${filtro.valor.inicio} - ${filtro.valor.fim}`}
              <span className="badge badge-light ml-2 clicavel"
                    onClick={() => this.props.removerFiltroTomador(filtro)}>&times;
              </span>
            </span>
          </div>
        )
      }
    } else {
      if (filtro.valor && filtro.valor.valor) {
        return (
          <div key={`${filtro.chave}${filtro.valor.valor}`} className="col-xl-auto justify-content-md-center">
            <span className="badge badge-secondary badge-filtro">
              {filtro.label} = {filtro.valor.valor}
              <span className="badge badge-light ml-2 clicavel"
                    onClick={() => this.props.removerFiltroTomador(filtro)}>&times;
              </span>
            </span>
          </div>
        )
      }
      return (
        <div key={`${filtro.chave}${filtro.valor}`} className="col-xl-auto justify-content-md-center">
          <span className="badge badge-secondary badge-filtro">
            {filtro.label} = {filtro.valor}
            <span className="badge badge-light ml-2 clicavel"
                  onClick={() => this.props.removerFiltroTomador(filtro)}>&times;
            </span>
          </span>
        </div>
      )
    }
  }

  render () {
    return this.props.filtrosAdicionadosTomador.map(filtro => this.exibirFiltro(filtro))
  }
}

const mapStateToProps = ({ filtrosAdicionadosTomador }) => ({ filtrosAdicionadosTomador });

const mapDispatchToProps = dispatch => bindActionCreators({
  removerFiltroTomador
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FiltrosAdicionadosTomador)
